<template>
  <div :style="style.container">
    <ModalCreateTenantTeam @created-tenant-team="fetchTenantTeams"/>
    <HeaderLargePrimary :style="style.header">
      Select team
    </HeaderLargePrimary>
    <TenantTeamCardList
      :isLoading="!loadedTenantTeams"
      :tenantTeams="tenantTeams"
      :tenantUser="tenantUser"
    />
    <div :style="style.paginationContainer">
      <PaginationPrimary
        v-if="pageNum > 1"
        v-model="currentPage"
        :disabled="!loadedTenantTeams"
        :pageNum="pageNum"
      />
    </div>
  </div>
</template>

<script>
  import ApiTenantTeam from '@js/api/tenant-team'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import ModalCreateTenantTeam from '@teamup/modals/modal-create-tenant-team'
  import PaginationPrimary from '@modules/pagination/pagination-primary'
  import TenantTeamCardList from '@teamup/modules/tenant-team-card-list'
  import { Layout } from '@js/styles'
  import { mapState } from 'vuex'

  export default {
    name: 'TeamupSelectView',
    components: {
      HeaderLargePrimary,
      ModalCreateTenantTeam,
      PaginationPrimary,
      TenantTeamCardList,
    },
    data: function () {
      return {
        currentPage: 1,
        loadedTenantTeams: false,
        pageSize: 11,
        tenantTeams: [],
        tenantTeamsCount: 0,
        style: {
          container: {
            margin: `${Layout.space.xl} auto ${Layout.space.lg}`,
            maxWidth: Layout.container.primary.maxWidth,
            width: '100%',
          },
          header: {
            margin: `0 0 ${Layout.space.md} 0`,
            padding: Layout.container.md.padding,
            //margin: `0 0 ${Layout.space.lg} 0`,
            //textAlign: 'center',
            //width: '100%',
          },
          paginationContainer: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            margin: `${Layout.space.lg} 0 0 0`,
            width: '100%',
          },
        },
      };
    },
    mounted: async function () {
      await this.fetchTenantTeams();
    },
    computed: {
      ...mapState({
        tenantUser: state => state.tenantUser,
      }),
      pageNum: function () {
        return Math.ceil(this.tenantTeamsCount / this.pageSize);
      },
    },
    methods: {
      fetchTenantTeams: async function () {
        try {
          this.loadedTenantTeams = await false;
          const api = await new ApiTenantTeam();
          const res = await api.get({
            page: this.currentPage,
            pageSize: this.pageSize,
            normalizeResponse: true,
          });
          this.tenantTeams = await res.data.results;
          this.tenantTeamsCount = await res.data.count;
          this.loadedTenantTeams = await true;
        } catch (error) {
          this.loadedTenantTeams = false;
          this.$store.commit('notification/setWarning', 'Failed to load teams');
          console.error(error);
        }
      },
    },
    watch: {
      currentPage: async function (newVal, oldVal) {
        await this.fetchTenantTeams();
      },
    },
  };
</script>
